var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { api } from '../../config/api';
import axios from '../../config/axios';
import { useAuth } from '../useAuth';
export var useBookmark = function () {
    var isAuthenticated = useAuth().isAuthenticated;
    var _a = useState([]), bookmarks = _a[0], setBookmarks = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var bookmarksKey = 'bookmarks';
    var bookmarksExpiresKey = 'bookmarksExpires';
    var bookmarksExpiresDays = 7;
    var saveBookmark = function (params, callback) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.post(api.bookmark.store(params), { link: window.location.href })];
                case 2:
                    response = _a.sent();
                    saveToStorage(response.data);
                    callback();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var saveToStorage = function (data, reset) {
        if (reset)
            return localStorage.setItem(bookmarksKey, JSON.stringify(data.bookmarks));
        var current = localStorage.getItem(bookmarksKey);
        var parsedCurrent = current ? JSON.parse(current) : [];
        var bookmarks = __spreadArray(__spreadArray([], parsedCurrent, true), [data.bookmarks], false);
        setBookmarksExpires();
        return localStorage.setItem(bookmarksKey, JSON.stringify(bookmarks));
    };
    var getBookmarks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var storage, response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storage = localStorage.getItem(bookmarksKey);
                    if (getBookmarksExpires(true) !== false && getBookmarksExpires(true) <= 0) {
                        localStorage.removeItem(bookmarksExpiresKey);
                        return [2 /*return*/, localStorage.setItem(bookmarksKey, JSON.stringify([]))];
                    }
                    if (!isAuthenticated()) {
                        return [2 /*return*/, setBookmarks(storage ? JSON.parse(storage) : [])];
                    }
                    if (storage)
                        setBookmarks(JSON.parse(storage));
                    if (!storage)
                        setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.get(api.bookmark.get)];
                case 2:
                    response = _a.sent();
                    saveToStorage(response.data, true);
                    setBookmarks(response.data.bookmarks);
                    return [3 /*break*/, 5];
                case 3:
                    e_2 = _a.sent();
                    console.log(e_2);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getCount = function () {
        var storage = localStorage.getItem(bookmarksKey);
        if (!storage)
            return null;
        return JSON.parse(storage).length;
    };
    var deleteBookmark = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var storage, parsed, filtered, response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storage = localStorage.getItem(bookmarksKey);
                    if (!storage)
                        return [2 /*return*/];
                    parsed = JSON.parse(storage);
                    filtered = parsed.filter(function (bookmark) { return bookmark.id !== id; });
                    setBookmarks(__spreadArray([], filtered, true));
                    saveToStorage({ bookmarks: filtered }, true);
                    if (!isAuthenticated()) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.post(api.bookmark.delete, { id: id })];
                case 2:
                    response = _a.sent();
                    saveToStorage(response.data, true);
                    return [3 /*break*/, 4];
                case 3:
                    e_3 = _a.sent();
                    console.log(e_3);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var setBookmarksExpires = function () {
        var today = new Date();
        var expireDate = today.setDate(today.getDate() + bookmarksExpiresDays);
        localStorage.setItem(bookmarksExpiresKey, JSON.stringify(expireDate));
    };
    var getBookmarksExpires = function (diff) {
        if (isAuthenticated())
            return false;
        var storage = localStorage.getItem(bookmarksExpiresKey);
        if (!storage)
            return false;
        var today = new Date();
        var expireDate = new Date(JSON.parse(storage));
        if (diff) {
            var diffTime = expireDate.getTime() - today.getTime();
            return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        return expireDate;
    };
    return {
        saveBookmark: saveBookmark,
        getBookmarks: getBookmarks,
        deleteBookmark: deleteBookmark,
        getCount: getCount,
        getBookmarksExpires: getBookmarksExpires,
        bookmarks: bookmarks,
        loading: loading,
    };
};
